let trustedHtmlFallbackForSession = false;

export function shouldUseTrustedHtmlFallbackForSession(): boolean {
  return trustedHtmlFallbackForSession;
}

export function rememberTrustedHtmlFallbackForSession(): void {
  trustedHtmlFallbackForSession = true;
}

export function __resetTrustedHtmlFallbackForTests(): void {
  trustedHtmlFallbackForSession = false;
}

export function isTrustedHtmlViolation(err: unknown): boolean {
  if (!isExpectedTrustedTypesError(err)) return false;
  const text = err instanceof Error ? `${err.name} ${err.message}` : String(err);
  return /TrustedHTML|Trusted Types/i.test(text);
}

function isExpectedTrustedTypesError(err: unknown): boolean {
  if (err instanceof TypeError) return true;
  return typeof DOMException !== 'undefined' && err instanceof DOMException;
}
